import { render, staticRenderFns } from "./ModalSelectContact.vue?vue&type=template&id=08cb06d2&scoped=true&lang=pug&"
import script from "./ModalSelectContact.vue?vue&type=script&lang=js&"
export * from "./ModalSelectContact.vue?vue&type=script&lang=js&"
import style0 from "./ModalSelectContact.vue?vue&type=style&index=0&id=08cb06d2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08cb06d2",
  null
  
)

export default component.exports